import React, { FC } from 'react'

import { Chip, ChipProps } from '@Components/Chips/Chip/Chip'
import { useTranslation } from '@Globals/Translations'

export const EngravableChip: FC<ChipProps> = ({ className }) => {
  const { t } = useTranslation()
  return (
    <Chip className={className} color="grey" size="small">
      {t('products:ENGRAVE_LABLE')}
    </Chip>
  )
}
